/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Priority_HighInputs */

const en_manual_qc_priority_high = /** @type {(inputs: Manual_Qc_Priority_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`High`)
};

const fr_manual_qc_priority_high = /** @type {(inputs: Manual_Qc_Priority_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elevee`)
};

const de_manual_qc_priority_high = /** @type {(inputs: Manual_Qc_Priority_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoch`)
};

const it_manual_qc_priority_high = /** @type {(inputs: Manual_Qc_Priority_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alto`)
};

const ru_manual_qc_priority_high = /** @type {(inputs: Manual_Qc_Priority_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Высокий`)
};

const es_manual_qc_priority_high = /** @type {(inputs: Manual_Qc_Priority_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alto`)
};

const zh_cn2_manual_qc_priority_high = /** @type {(inputs: Manual_Qc_Priority_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高的`)
};

const ja_manual_qc_priority_high = /** @type {(inputs: Manual_Qc_Priority_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高い`)
};

const hi_manual_qc_priority_high = /** @type {(inputs: Manual_Qc_Priority_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उच्च`)
};

const pt_pt2_manual_qc_priority_high = /** @type {(inputs: Manual_Qc_Priority_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alto`)
};

/**
* | output |
* | --- |
* | "High" |
*
* @param {Manual_Qc_Priority_HighInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_priority_high = /** @type {((inputs?: Manual_Qc_Priority_HighInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Priority_HighInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_priority_high(inputs)
	if (locale === "de") return de_manual_qc_priority_high(inputs)
	if (locale === "it") return it_manual_qc_priority_high(inputs)
	if (locale === "ru") return ru_manual_qc_priority_high(inputs)
	if (locale === "es") return es_manual_qc_priority_high(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_priority_high(inputs)
	if (locale === "ja") return ja_manual_qc_priority_high(inputs)
	if (locale === "hi") return hi_manual_qc_priority_high(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_priority_high(inputs)
	return en_manual_qc_priority_high(inputs)
});